<template>
  <div
    id="additional-products"
    class="flex flex-col gap-3 mt-4 z-10"
  >
    <div class="flex gap-4 items-center justify-between">
      <h3 class="font-bold">
        Browse more flavors:
      </h3>
      <ProductFilterSelect
        hide-label
        class="min-w-[180px] w-1/3"
      />
    </div>

    <div :class="collapsed && 'collapsed'">
      <div class="grid gap-4 grid-view grid-cols-2 md:grid-cols-3">
        <ProductCard
          v-for="prod in products.slice(0, collapsed ? $breakpoints.md.value ? 4 : 6 : 99)"
          :key="prod.id"
          :product="prod"
          compact
        />
      </div>
    </div>
    <button
      v-if="collapsed"
      class="button border-black button-expand"
      @click.prevent="collapsed = false"
    >
      Show more flavors
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useProductsStore } from '@/stores/products'
import ProductCard from './product-card.vue'
import ProductFilterSelect from './product-filter-select.vue'

const store = useProductsStore()
const { product, filteredProducts } = storeToRefs(store)
const collapsed = ref(true)
const products = computed(() => {
  const { value } = filteredProducts
  const id = product.value?.id || 0
  const index = value.findIndex(i => i.id === id)
  if (index >= 0) {
    value.splice(index, 1) // remove current flavor
  }
  const before = value.slice(0, index)
  const after = value.slice(index, value.length)
  return after.concat(before)
})
</script>

<style scoped>
@reference 'tailwindcss';

.collapsed {
  /* Clip on this wrapper, NOT the grid, so the grid lays out at natural height
     and the cards are never sized relative to the clip (which would squash the
     row tracks and cut off card content). Shows row 1 + a peek of row 2.
     Break at lg, where the card grows (image wrapper h-40 -> h-56). */
  @apply relative overflow-hidden max-h-[420px] lg:max-h-[490px] z-0;
}
.button-expand:before {
  content: '';
  position: absolute;
  height: 100px;
  left: -1px;
  top: -110px;
  right: -1px;
  z-index: 1;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
}
</style>
